import axios from "axios";

// Resolve the backend URL at runtime (not just build time) so the production deploy
// (e.g. https://agrihansa.com) calls its own backend instead of the preview URL that
// might have been baked into the build at compile time.
function resolveBackendUrl() {
  if (typeof window === "undefined") return process.env.REACT_APP_BACKEND_URL || "";
  const envUrl = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
  const origin = window.location.origin;
  // If env URL is missing OR points to a different origin than the page, use the page origin
  // (Kubernetes ingress in production routes /api/* to the backend pod).
  if (!envUrl) return origin;
  try {
    const u = new URL(envUrl);
    if (u.origin === origin) return envUrl;
    return origin;
  } catch {
    return origin;
  }
}

const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    // Only treat 401s from our own auth/session as expiry — third-party proxy
    // endpoints (GSTIN lookup etc.) can bubble 401s that are NOT session issues.
    const isProxied401 = url.includes("/gstin/") || url.includes("/lookup/");
    if (status === 401 && !isProxied401 && window.location.pathname !== "/login") {
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function fmtINR(n) {
  const v = Number(n || 0);
  return "₹ " + v.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    // Plain calendar dates (YYYY-MM-DD) must not be shifted by the browser's timezone
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso).slice(0, 10));
    const d = m && String(iso).length <= 10 ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
}
